import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {IDialogComponent} from "../../../common/dialog/iDialog.component";
import {DialogWithInput} from "../../../common/dialog/dialogWithInput";
import {DialogModule} from "../../../common/dialog/dialog.module";

export interface ImagePreviewDialogInput {
  image: string; // URL or base64
}

@Component({
  selector: 'app-image-preview-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule],
  templateUrl: './image-preview-dialog.component.html',
  styles: [
  ]
})
export class ImagePreviewDialogComponent implements IDialogComponent<ImagePreviewDialogInput, void>{
  dialog: DialogWithInput<ImagePreviewDialogInput, void>;
}
